var io = require('socket.io-client');

function socket() {
  if (!this)
    return new socket();
  this.socket = null;
}

socket.prototype.connect = function (vm, token, initialize) {
  var self = this;
  var events = vm.$options.api.events;
  function connect(type) {
    if (type !== 'new')
      delete self.socket;
    self.socket = io({query: {T: token}});
    self.socket
      .once('connect', function () {
        console.debug('socket connected', self.socket.id);
        initialize(self.socket.connected);
        for (var key in events)
          self.socket.on(key, events[key]);
      })
      .on('connect_error', function (error) {
        console.error('socket connection error', error);
        if (initialize)
          initialize();
      })
      .on('disconnect', function (reason) {
        console.debug('socket disconnected', reason);
      });
  }
  if (this.socket)
    this.disconnect(connect);
  else
    connect('new');
};

socket.prototype.disconnect = function (callback) {
  if (!this.socket)
    return;
  var self = this;
  this.socket
    .on('disconnect', callback || function () {delete self.socket})
    .disconnect();
};

socket.prototype.on = function (event, callback) {
  var socket = this.socket;
  if (typeof event === 'string')
    socket.on(event, callback);
  else
    Object.keys(event).forEach(function (key) {socket.on(key, event[key])});
};

socket.prototype.emit = function (...args) {
  this.socket.emit(...args);
};

socket.prototype.connected = function () {
  return this.socket.connected;
};

export default socket;
